import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ar from "./locales/ar.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

const STORAGE_KEY = "erp_auth_lang";
const DEFAULT_LANGUAGE = "ar";

const normalizeLanguage = (lng) => {
  const base = (lng || DEFAULT_LANGUAGE).split("-")[0];
  if (base === "ar") return "ar";
  if (base === "fr") return "fr";
  return "en";
};

const applyLanguageSettings = (lng) => {
  if (typeof document === "undefined") return;
  const lang = normalizeLanguage(lng);
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      en: { translation: en },
      fr: { translation: fr },
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: ["ar", "en", "fr"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
    returnNull: false,
    returnEmptyString: false,
  });

applyLanguageSettings(i18n.language);
i18n.on("languageChanged", applyLanguageSettings);

export default i18n;
